import React from 'react'
import {Redirect} from 'react-router-dom'
import {useSelector} from 'react-redux'

import PropTypes from 'prop-types'

import {makeStyles} from '@material-ui/core/styles'
import {Typography, Grid, Hidden, Container} from '@material-ui/core'

import Page from 'components/Page/Page'
import KioskUserGuides from 'views/HelpCenterPage/KioskUserGuides';

const useStyles = makeStyles((theme) => ({}))


const HelpCenter = (props) => {
  const auth = useSelector(state => state.auth)
  const classes = useStyles()

  const tenant = useSelector(state => state.auth.tenant)

  if (!auth.access_token) {
    return <Redirect to="/login"/>
  }

  function hasPermission(perm) {
    for (var i = 0; i < auth.permissions.length; i++) {
      if (auth.permissions[i][0] == perm[0] && auth.permissions[i][1] == perm[1]) {
        return true
      }
    }
    return false
  }

  return (
    <Page title="Dashboard">
      <Container maxWidth={false} style={{'marginBottom': '50px'}}>

        {(hasPermission(["Admin", "admin"]) || hasPermission(["Normal", "user"])) &&
          <KioskUserGuides/>
        }

      </Container>
    </Page>
  )
}

export default HelpCenter